import wechatAuth from './wechatAuth'
import store from '../../store'
// import localStorage from '@utils/localstorage'
import request from '@/utils/request'
export default {
  install(Vue, options) {
    let router = options.router
    options.vue = Vue
    let wechatPlugin = new wechatAuth(options)
    if (!router) return false
    //绑定到路由上
    router.beforeEach((to, from, next) => {
      // 查询系统参数
      if (store.getters.ifyik === '' || store.getters.iffsd === '' || store.getters.ifyyorqhpay === '' || store.getters.ifyyorqhpay === '') {
        request.get("/open/sysparams").then((res) => {
          if (res.success) {
			// 初始化系统参数
            store.dispatch('SetIfyik', res.result.ifyik)			// 医卡模式（0：无卡，1：有卡）
            store.dispatch('SetIffsd', res.result.iffsd)			// 分时段挂号（0：停用，1：启用）
            store.dispatch('SetIfyyorqhpay', res.result.ifyyorqhpay)// 预约或取号支付（0：预约，1：取号）
			store.dispatch('SetIfksorysgh', res.result.ifksorysgh)	// 挂号模式（0：科室，1：专家）
			store.dispatch('SetIfmenzth', res.result.ifmenzth)		// 门诊退号（0：停用，1：启用）
			store.dispatch('SetIfdzjkk', res.result.ifdzjkk)		// 电子健康卡（0：停用，1：启用）
			store.dispatch('SetIfybmzgh', res.result.ifybmzgh)		// 医保移动支付门诊挂号（0：停用，1：启用）
			store.dispatch('SetIfybmzjf', res.result.ifybmzjf)		// 医保移动支付门诊缴费（0：停用，1：启用）
            // 判断是否开启内部测试
            if (res.result.iftest == '1') {
              sessionStorage.setItem("iftest", '1')
            } else {
              sessionStorage.setItem("iftest", '')
            }
          } else {
            next('/CommonError/' + res.message)
          }
        })
      }
      if (to.matched.some(record => record.meta.wechatAuth)) {
        // 测试环境下执行
        if (process.env.VUE_APP_DEV_TOKEN) {
          // sessionStorage.setItem('USER_TOKEN', process.env.VUE_APP_DEV_TOKEN)
          request.get('/patient/getToken?openId=wxecbfefd7c5084cab').then(res => {
            if (res.success) {
              sessionStorage.setItem('USER_TOKEN', res.result)
            }
          })
        }
        //判断是否存储token
        if (sessionStorage.getItem('USER_TOKEN')) {
          //如果开启内测，判断用户是否为测试用户
          if (sessionStorage.getItem('iftest') == 1) {
            request.get(
              '/patient/checkTestUser'
            ).then(res => {
              if (!res.success) {
                next('/CommonError/' + "公众号升级中...");
              }
            })
          }
          //检验是否注册绑定
          if (to.matched.some(record => record.meta.ifBind)) {
            request.get(
              '/patient/checkIfBind'
            ).then(res => {
              if (res.success) {
                next();
              } else {
                //跳转error页面
                next('/patientAdd');
              }
            })
          } else {
            next()
          }
        } else if (to.query.code && to.query.code.length > 4) {
          //判断code是否存在，并且长度大于0
          console.log("没有token,有code,根据code获取微信用户信息，再根据openid获取token")
          wechatPlugin.getCodeCallback(next, to.query.code)
        } else {
          //否则去获取token 
          console.log("没有token,没有code,调取微信获取code接口")
          if (process.env.NODE_ENV == 'production') {
            wechatPlugin.getCode()
          } else {
            next()
          }
        }
      } else {
        next()
      }
    })
  }
}
